<convfact-quarterly-tax-receipt-edit [model]="model" *ngIf="model" (onSave)="saveData($event)">
</convfact-quarterly-tax-receipt-edit>